import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
const FIRST_DELAY = 9000;
const VISIBLE_MS = 5500;
const GAP_MS = 13000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const show = () => {
      setVisible(true);
      timeout = window.setTimeout(hide, VISIBLE_MS);
    };
    const hide = () => {
      setVisible(false);
      setIndex(prev => (prev + 1) % purchaseNotifications.length);
      timeout = window.setTimeout(show, GAP_MS);
    };
    timeout = window.setTimeout(show, FIRST_DELAY);
    return () => window.clearTimeout(timeout);
  }, [dismissed]);
  const current = purchaseNotifications[index];
  return <AnimatePresence data-id="element-33" data-mp="1gwujam4190nh">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      y: 14,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 14,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-50 sm:left-5 sm:right-auto sm:max-w-sm" role="status" aria-live="polite" data-id="element-34" data-mp="164oas9ct49vr">
          <div className="flex items-start gap-3 rounded-xl border border-teal-500/25 bg-white px-3.5 py-3 shadow-[0_16px_40px_-16px_rgba(4,12,19,0.6)]" data-id="element-35" data-mp="n7wmflier4ku">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal-600" aria-hidden="true" data-id="element-36" data-mp="x519ronzp638" />
            <div className="min-w-0 flex-1" data-id="element-37" data-mp="s6hjxd69za5l">
              <p className="text-[13px] font-bold leading-snug text-ink-900" data-id="element-38" data-mp="s4mzdzyx1k21">
                {current.name} just purchased the Route
              </p>
              <p className="mt-0.5 text-[11px] font-medium text-ink-900/55" data-id="element-39" data-mp="23lmz3gnlf163">
                {current.place} · a few moments ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="-mr-1 -mt-1 rounded-md p-1 text-ink-900/35 transition-colors duration-150 ease-out hover:text-ink-900" data-id="element-40" data-mp="2aqnumxjs857z">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-41" data-mp="2plbzc9hcyzmj" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}